
export { FeedFiltersType } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/feeds/models/index.ts"
export { LOADER_ACTIVTIES_INTERVAL } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/feeds/models/index.ts"
export { useLoaderActivities } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/feeds/hooks/index.ts"